export const environment = {
  production: true,
  apiUrl: 'https://teamadminapi.politepond-8e0e61ed.westeurope.azurecontainerapps.io/api',
  notificationSignalrHubUrl: 'https://teamadminapi.politepond-8e0e61ed.westeurope.azurecontainerapps.io/notifications',
  appInsights: {
    connectionString:
      'InstrumentationKey=bfb5800e-c8fa-4491-8c6a-9fa72f625881;IngestionEndpoint=https://westeurope-4.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=ef5c57f2-1dbe-4d34-96e8-7504eed6d524',
    cloudRoleInstance: 'teamadminapp',
  },
};
